// import { IS_MARRY_BABY } from 'interfaces/constants'
import styled, { css } from 'styled-components'

const IS_MARRY_BABY = true

export const StyledSubmitReportForm = styled.div`
  padding: 0 8px;
  margin-top: 18px;

  .report-list {
    margin-bottom: 18px;

    .report-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-weight: 600;

      & > img {
        width: 12px;
        height: 12px;
        margin-right: 8px;
      }

      .__label {
        font-size: 14px;
      }
    }
  }

  .report-submit {
    width: 100%;
  }
  ${IS_MARRY_BABY
    ? css`
        padding: 0 1rem 1rem;
      `
    : ''}
`
